export default __webpack_public_path__ + "static/iceland-856f1e92c33908178fb6616d8f263674.jpg";